export default defineNuxtRouteMiddleware(async (currentRoute) => {  
  const backend = useBackend();
  const { getMetaTags } = backend;

  const response = await getMetaTags(currentRoute.fullPath);
  const { data: metaTags, status } = response;

  if (status === 404) {
    return;
  }

  const defaultTitle = "Vehis.pl - Atrakcyjny leasing samochodów nowych i używanych";
  const defaultDescription = "Leasing samochodów z atrakcyjnymi warunkami finansowania u lidera w branży ✔️ Decyzja w 15 min. Sprawdź!";

  const title = metaTags?.title || defaultTitle;
  const description = metaTags?.description || defaultDescription;
  useState('cmsPageMainHeader', () => metaTags?.h1); // Store h1 in a state for page use

  useHead({
    title,
    meta: [
      { name: "description", content: description },
    ]
  });
});